export default "__VITE_ASSET__vjjyFPV___"